import * as React from 'react'
import { ActiveIds, Toggleable } from './interface'

const defaultValue = {
  activeIds: [],
  toggle: () => {},
}

const { Provider, Consumer } = React.createContext<ActiveIds & Toggleable>(defaultValue)

export { Provider, Consumer }
